<div class="mainMenu" [ngClass]="{ mainMenuClose: !isExpanded, mainMenuOpen: isExpanded }"
  (click)="onMainMenuClick($event)">
  <div class="avatarOpen">
    <div class="boxAvatar" (click)="$event.stopPropagation()">
      <div class="circleAvatar" [class.has-photo]="!!profilePhoto"
        [style.background-image]="profilePhoto ? 'url(' + profilePhoto + ')' : null" [ngClass]="{
    circleAvatarOpen: isExpanded,
    circleAvatarClose: !isExpanded
  }" [title]="userName" (click)="toggleBadges($event)">
        <ng-container *ngIf="!profilePhoto">{{ firstUserName }}</ng-container>
      </div>

      <div class="avatar-dot" [ngClass]="{ 'has-notifications': hasNewNotifications }"
        [title]="showBadges ? 'Fechar cinturão' : 'Abrir cinturão'" (click)="toggleBadges($event)">
        <span *ngIf="hasNewNotifications && !showBadges">{{ notificationCount > 99 ? '99+' : notificationCount }}</span>
      </div>

      <div class="badges-wrapper" *ngIf="showBadges" (click)="$event.stopPropagation()">
        <div class="badge-item badge-trophy badge-enter-1" [title]="pointsTooltip" (click)="$event.stopPropagation()">
          <i class="fa-solid fa-trophy"></i>
        </div>
        <div class="badge-item badge-star badge-enter-2" [ngClass]="{ 'is-complete': isProfileComplete }"
          [title]="profileTooltip" (click)="goToProfile($event)">
          <i class="fa-solid fa-star"></i>
        </div>
        <div class="badge-item badge-bell badge-enter-3" [ngClass]="{ 'has-alert': hasNewNotifications }"
          [title]="notificationsTooltip" (click)="goToNotifications($event)">
          <i class="fa-solid fa-bell"></i>
          <span class="badge-count" *ngIf="hasNewNotifications">{{ notificationCount > 99 ? '99+' : notificationCount
            }}</span>
        </div>
        <div class="badge-item badge-water badge-enter-4" [title]="waterTooltip" (click)="$event.stopPropagation()">
          <i class="fa-solid fa-droplet"></i>
        </div>
        <div class="badge-item badge-fire badge-enter-5" [title]="fireTooltip" (click)="$event.stopPropagation()">
          <i class="fa-solid fa-fire"></i>
        </div>
      </div>
    </div>
    <div class="avatarName" [class.avatarNameHidden]="!isExpanded" (click)="$event.stopPropagation()">
      <div class="boxAvatar">
        <h6>{{ userName }}</h6>
      </div>
    </div>
  </div>

  <div class="menuViewport">
    <div class="menuSpacer" aria-hidden="true"></div>

    <ul class="menu" (click)="$event.stopPropagation()">
      <a class="navLink" tabindex="0" routerLink="/home" routerLinkActive="active">
        <div class="navIcon">
          <i class="fa-solid fa-house"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Home</p>
        </div>
      </a>
      <a class="navLink" tabindex="0" routerLink="/mural" routerLinkActive="active">
        <div class="navIcon">
          <i class="fa-solid fa-layer-group"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Comunicações</p>
        </div>
      </a>
      <a class="navLink" tabindex="0" routerLink="/campaigns" routerLinkActive="active">
        <div class="navIcon">
          <i class="fa-solid fa-bullhorn"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Campanhas</p>
        </div>
      </a>
      <a class="navLink" tabindex="0" routerLink="/users" routerLinkActive="active">
        <div class="navIcon">
          <i class="fa-solid fa-user"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Usuários</p>
        </div>
      </a>
      <a class="navLink" tabindex="0" routerLink="/company-details" routerLinkActive="active">
        <div class="navIcon">
          <i class="fa-solid fa-briefcase"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Empresas</p>
        </div>
      </a>
      <!-- <a class="navLink" tabindex="0" routerLink="/chat" routerLinkActive="active">
        <div class="navIcon">
          <i class="fa-solid fa-comments"></i>
        </div>
        <div class="navText" [ngClass]="{ hidden: !isExpanded }">
          <p class="navTextFont">Chat</p>
        </div>
      </a> -->
      <a class="navLink" tabindex="0" routerLink="/management" [class.active]="isManagementRouteActive()">
        <div class="navIcon">
          <i class="fa-solid fa-gear"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Gestão</p>
        </div>
      </a>
      <a class="navLink" tabindex="0" routerLink="/reports" [class.active]="isReportsRouteActive()">
        <div class="navIcon">
          <i class="fa-solid fa-chart-column"></i>
        </div>
        <div class="navText" [class.navTextCollapsed]="!isExpanded">
          <p class="navTextFont">Relatórios</p>
        </div>
      </a>
    </ul>

    <div class="menuSpacer" aria-hidden="true"></div>
  </div>

  <div class="logoBox" (click)="toggleMenu()">
    <img
      [src]="logoUrl || 'assets/logo-rsm-white.svg'"
      alt="RSM"
      class="logoRSM logoRSMExpanded"
      [class.logoHidden]="!isExpanded"
      title="RSM"
    />
    <img
      src="assets/logo/favicon.svg"
      alt="RSM"
      class="logoRSM logoRSMCollapsed white-filter"
      [class.logoHidden]="isExpanded"
      title="RSM"
    />
  </div>
</div>
